import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { GenericHandler } from './GenericPageHandler';
import { imagesLoaded } from 'imagesloaded';

export class AboutPageHandler extends GenericHandler {
    constructor(id) {
        super(id);
		this.$imgOne = jQuery('about-section__image-box:eq(0)')
		this.$imgTwo = jQuery('about-section__image-box:eq(1)')
		this.$imgThree = jQuery('about-section__image-box:eq(2)')
    }

	transitions() {
		jQuery('.about-section__image-box').each((index, item) => {
			jQuery(item).imagesLoaded(() => {
				gsap.fromTo(item, {autoAlpha: 0}, {autoAlpha: 1, duration: 0.5})
			})
		})
		jQuery('.about-section__text-box').each((index, item) => {
			ScrollTrigger.create({
				trigger: item,
				start: "top 80%",
				onLeaveBack: self => self.disable(),
				onEnter: () => {
					gsap.fromTo(item, {y: 50, autoAlpha: 0}, {y: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inout"})
				}
			})
		})
		jQuery('.about-section__store').each((index, item) => {
			ScrollTrigger.create({
				trigger: item,
				start: "top 80%",
				onLeaveBack: self => self.disable(),
				onEnter: () => {
					gsap.fromTo(item, {y: 50, autoAlpha: 0}, {y: 0, autoAlpha: 1, duration: 0.8, ease: "power2.inout"})
				}
			})
		})
	}

    init() {
		
    }  

    destroy() {

    }

	events() {
		
	}
}